import React, { useMemo } from "react";
import { cn } from "utils";
import ChevronLeft from "assets/images/icon/chevron-left";
import ChevronRight from "assets/images/icon/chevron-right";
import IconButton from "./IconButton";

const Pagination = React.forwardRef(({
    totalPages = 1,
    currentPage = 1,
    onPageChange,
    className,
    style,
    ...rest
}, ref) => {
    const pagesArr = useMemo(() => {
        const arr = [];
        for (let i = 1; i <= totalPages; i++) arr.push(i);
        return arr;
    }, [totalPages]);

    return (
        <div ref={ref} className={cn("pagination-container", className)} style={{ ...style }} {...rest}>
            <div className="pagination">
                <IconButton onClick={() => onPageChange && onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                    <ChevronLeft />
                </IconButton>
                {pagesArr.map((pageNum) => (
                    <button
                        key={pageNum}
                        className={cn("page_number", currentPage === pageNum ? "active" : "inactive")}
                        onClick={() => onPageChange && onPageChange(pageNum)}
                    >
                        {pageNum}
                    </button>
                ))}
                <IconButton onClick={() => onPageChange && onPageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                    <ChevronRight />
                </IconButton>
            </div>
        </div>
    );
});

export default Pagination;
